import React from 'react'
import './styles.scss'

const ModalBackdrop = props => <div className="modal-backdrop" {...props} />

export default ModalBackdrop
